document.addEventListener("DOMContentLoaded", function () {
  function extractField(field) {
    const obj = window.dataLayer?.find((e) => e.customer)?.customer || {};
    return obj[field] || null;
  }

  async function sha256(value) {
    const encoded = new TextEncoder().encode(value.trim().toLowerCase());
    const buffer = await crypto.subtle.digest("SHA-256", encoded);
    return Array.from(new Uint8Array(buffer))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  }

  async function pushToDataLayer() {
    const rawEmail = window.customer_email
      ? window.customer_email
      : extractField("email");
    const rawPhone = window.customer_phone
      ? window.customer_phone
      : extractField("phone");
    const customerId = window.customer ? window.customer : extractField("id");
    const userId = extractField("user_id");
    const zip = extractField("zip");
    const storeId = Shopify?.shop || "barfers-wellfood.myshopify.com";
    try {
      const [emailHash, phoneHash] = await Promise.all([
        rawEmail ? sha256(rawEmail) : null,
        rawPhone ? sha256(rawPhone) : null,
      ]);

      const payload = {
        event: "criteo_identity_ready",
        ...(emailHash && { user_email_sha256: emailHash }),
        ...(phoneHash && { user_phone_sha256: phoneHash }),
        ...(customerId && { user_id: customerId }),
        ...(userId && { user_uuid: userId }),
        ...(zip && { user_zip: zip }),
        store_id: storeId,
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      localStorage.setItem("criteo_inited", "true");
    } catch (error) {
      console.error("criteo_identity_fails");
      localStorage.removeItem("criteo_inited", null);
    }
  }

  function tryInject() {
    if (window.customer) {
      if (!localStorage.getItem("criteo_inited")) {
        pushToDataLayer();
        console.log("criteo_inited");
      }
    } else {
      localStorage.removeItem("criteo_inited");
    }
  }

  tryInject();

  const getHashed = async (rawEmail) => {
    const normalizedEmail = rawEmail.trim().toLowerCase();
    if (!normalizedEmail) {
      console.error("Normalized email is empty");
      return;
    }

    const encoder = new TextEncoder();
    const data = encoder.encode(normalizedEmail);

    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashedEmail = Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");

    if (!hashedEmail) {
      console.error("Hashing failed");
      return;
    }
    return hashedEmail;
  };

  const getHashedEmail = async () => {
    const hashed_data = localStorage.getItem("hashed_data");
    const email = window.customer_email;
    if (hashed_data) {
      const parsed = JSON.parse(hashed_data);
      if (parsed?.email && parsed?.hashed_email) {
        return parsed?.hashed_email;
      }
    } else if (email) {
      try {
        const hashed_email = await getHashed(email);
        if (hashed_email) {
          const hashed_data = {
            email,
            hashed_email,
          };
          localStorage.setItem("hashed_data", JSON.stringify(hashed_data));
          return hashed_email;
        }
      } catch (error) {
        console.error("Hashed email error");
      }
    }
  };

  let emailIsAlreadySended = false;

  const sendDataLayerHashedEmail = (hashedEmail) => {
    if (hashedEmail) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "criteo_email_ready",
        user_email_sha256: hashedEmail,
      });

      emailIsAlreadySended = true;

      console.log(
        `Email: successfully hashed: ${hashedEmail} and pushed to dataLayer`
      );
    }
  };

  const initHasher = async () => {
    const hashed_email = await getHashedEmail();

    sendDataLayerHashedEmail(hashed_email);
  };

  initHasher();
});
